import clsx from 'clsx';
import { Box } from '../Box';

import styles from './index.module.css';

type AlignOptions = 'center' | 'start' | 'end' | 'baseline';
type GapOptions = 's' | 'xxs' | 'xs' | 'm' | 'ms' | 'l' | 'xl' | 'xxl' | 'xxxl';

interface NativeSliderProps {
  className?: string;
  children?: React.ReactNode;
  role?: string;
  align?: AlignOptions;
  gap?: GapOptions;
}

export const NativeSlider: React.FC<NativeSliderProps> = ({
  className,
  children,
  role,
  align,
  gap
}) => {
  return (
    <Box
      data-role={role}
      className={clsx([styles.wrapper, className])}
      align={align}
      gap={gap}
    >
      {children}
    </Box>
  );
};
